// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s2qk","inner":"styles_inner__2HokN","right":"styles_right__1iC5a","close":"styles_close__H3Tml","footer":"styles_footer__29VOO"};